import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// native components
import ClientServicesHours7to5 from '../../../../../components/clientServicesHours7to5';

export default () => (
  <SectionContainer
    id='life-insurance-faq-submit-waiver-premium-claim'
    backgroundVariant='lightB'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Submit a Waiver of Premium Claim
        </Typography>
        <Typography nextElement='typography'>
          If you have been disabled for at least six months due to an accident or illness, and you purchased the waiver of premium
          benefit on any of your life insurance or annuity policies, you may be able to suspend payment of your premiums on these
          policies.
        </Typography>
        <Typography nextElement='typography'>
          To notify Northwestern Mutual of a disability,
        </Typography>
        <BulletedList
          bulletedListData={[
            {
              bulletText: <>Complete the <Link
                id='disability-claim-form-link'
                linkUrl='/notice-of-disability-form/'
                variant='primaryDeemphasize'>
                File a Disability Claim form
              </Link></>,
            },
            {
              bulletText: <>
                Or call Northwestern Mutual at{' '}
                <Link
                  id='life-insurance-faq-submit-waiver-premium-claim-selection-toll-free-number-link'
                  ariaLabel='Call to file a disability claim form'
                  linkUrl='tel:8007489493'
                  variant='primaryDeemphasize'>
                  1&#45;800&#45;748&#45;9493
                </Link>
                , ext. 6612016,{' '}
                <ClientServicesHours7to5 />
              </>,
            },
          ]}
        />
        <Typography nextElement='typography'>
          We will mail you a personalized claim kit within two business days of receiving your notification of disability. The kit contains forms and instructions you will need to file your claim.
        </Typography>
        <Typography nextElement='typography'>
          If you also have the waiver of premium benefit on your life insurance or annuity and IRA policies, one notification begins
          the claim process for both your disability income insurance and the waiver of premium benefit.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Premiums Payments During the Claim Process
        </Typography>
        <Typography nextElement='typography'>
          In order to protect your policy rights, you should continue to pay premiums on all of your Northwestern Mutual policies until your disability claim is approved.
        </Typography>
        <Typography nextElement='typography'>
          After your claim has been approved, we will refund any premiums paid on your disability insurance policy back to the date
          of disability as determined during the review of your claim.
        </Typography>
        <Typography disableBottomPadding>
          These premiums will be refunded to the premium payer.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
